// Copyright (c) Move Closer 2022.

import { Component, Prop, Vue } from 'vue-property-decorator'

import { Module, ModuleContent } from '../../../../../contexts'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
@Component
export class AbstractMegaMenuAddon extends Vue {
  @Prop({ type: Object, required: true })
  public readonly data!: ModuleContent

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public get moduleData (): Module<any, any> {
    return this.wrapAddon(this.data)
  }

  protected wrapAddon (addon: ModuleContent) {
    return {
      driver: addon.type,
      id: '',
      isVisible: true,
      title: '',
      content: { ...addon.content }
    }
  }
}
